module.exports = __webpack_public_path__ + "static/img/Healthy.48be087.png";